import React, { ReactElement } from 'react'
import TrustedByExperts from '../TrustedByExperts/TrustedByExperts'
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions'
import ReadyToGetStarted from '../CommonSections/RedyToGetStarted'
import HeroSection from 'components/Organization/LandingPageCommonComponents/HeroSection'
import HeroIcon from 'images/organization/features/analytics/hero.svg'
import FeatureUseCases from '../CommonSections/UseCases/FeatureUseCases'
import CompactFeatures, {
  FeaturesDivider,
  FeaturesItem,
} from 'components/Organization/LandingPageCommonComponents/CompactFeatures'
import MonitoringIcon from 'images/organization/features/analytics/monitoring.svg'
import DetailedInsights from 'images/organization/features/analytics/detailed-insights.svg'
import TrustedIcon from 'images/organization/features/malware/trusted.svg'
import ReportingIcon from 'images/organization/features/analytics/reporting.svg'
import SectionDivider from 'components/Organization/LandingPageCommonComponents/SectionDivider'
import FeaturePageLayout from 'components/Organization/LandingPageCommonComponents/LandingPageLayout'
import analyticsUseCasesData from './Sections/analyticsUseCasesData'
import ComprehensiveAnalytics from './Sections/ComprehensiveAnalytics'
import { frequentlyAskedQuestions } from './Sections/frequentlyAskedQuestions'

export default function Analytics(): ReactElement {
  return (
    <FeaturePageLayout>
      <HeroSection
        title="Powerful Analytics with Control D"
        description={`Gain powerful insights into your network with Control D’s comprehensive analytics tooling.
         With real-time statistics and customizable reports, you can identify issues, optimize network performance,
          and enhance security across your entire organization.`}
        svg={HeroIcon}
      />

      <CompactFeatures>
        <FeaturesItem icon={MonitoringIcon} title="Real-time monitoring" />
        <FeaturesDivider />
        <FeaturesItem icon={DetailedInsights} title="Detailed insights" />
        <FeaturesDivider />
        <FeaturesItem icon={TrustedIcon} title="Trusted by experts" />
        <FeaturesDivider />
        <FeaturesItem icon={ReportingIcon} title="Customizable reporting" />
      </CompactFeatures>

      <FeatureUseCases
        title="Keep your employees engaged and secure"
        data={analyticsUseCasesData}
      />
      <SectionDivider />

      <ComprehensiveAnalytics />
      <SectionDivider />

      <TrustedByExperts />
      <SectionDivider />

      <FrequentlyAskedQuestions data={frequentlyAskedQuestions} />
      <SectionDivider />

      <ReadyToGetStarted />
    </FeaturePageLayout>
  )
}
